<template>  
      <div class="container">
                <div class="page-header">
                    <div class="page-title">
               
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'صلاحية'" :to="{name: 'roles'}">الصلاحيات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'صلاحية'" :to="{name: 'roles.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                             <i class="flaticon-computer-4"></i> 
                                          بيانات الصلاحية</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                    <div class="row">
                                         <div class="col-md-6">
                                             <label for="exampleFormControlInput12">اسم الصلاحية</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                        <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"   v-if="getErrors['name']">
                                              {{ getErrors['name'][0] }}
                                        </div>
                                    </div>
                                     </div>
                                    <div class="form-group mb-4">
                                        <label for="exampleFormControlInput12">جميع الصلاحيات</label>
                                         <input style="height: 25px" class="form-control" type="checkbox"  @click="selectAll()" v-model="data.allSelected">
                                        <div class="col-md-12">
                                          <div class="invalid-feedback" :style="getErrors['permissions'] ? 'display: block' : 'display: none;'"   v-if="getErrors['permissions']">
                                              {{ getErrors['permissions'][0] }}
                                        </div>
                                      </div>
                                    </div>
                                     </div>
                                    <div class="row">
                                      <div class="col-md-4  mb-3  text-center" v-for="(v, k) in data.permissions"  :key="k">
                                      <div class="role-box">
                                        <div class="row mb-2 role-selected">
                                          <input type="checkbox"
                                                :id="k"
                                                @click="selectBox(v, $event)"
                                                :checked="data.form.permissions.includes(k)"
                                                class="form-control col-md-4"
                                                style="height: 25px">
                                          <label class="col-md-4" :for="k">{{ trans.roles_label[k] }}</label>
                                        </div>

                                        <div class="row mb-2" v-for="(v2, k2) in v" :key="k2">
                                          <input @click="select"  style="height: 25px" class="form-control col-md-4" type="checkbox" :id="k2" :value="k2" v-model="data.form.permissions">
                                          <label class="col-md-4" :for="k2">{{ trans.action[v2] }}</label>
                                        </div>
                                        
                                      </div>
                                    </div>
                                    </div>
                                    
                                    <!-- <input type="submit" name="time" class="mt-4 mb-4 btn btn-button-7" value="حفظ"> -->
                                    <button type="submit" name="time" value="حفظ" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'roles'}">
                                      <span>رجوع</span>
                                    </router-link>

                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      trans: {},
      data: {
        checkerExit: 0,
        form: {
          name: '',
          permissions: [],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      }
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    resetForm(){
      this.data.form = {
          name: '',
          permissions: [],
        }
    },
    getPermissions() {
      this.$baseApi.get('/roles/get/permissions').then((response) => {
        if (response.data.code == 200) {
          this.data.permissions = response.data.data;
        } else {
          alert(response.data.error.error);
        }
      });
    },
    getInfo() {
      this.$baseApi.get('/roles/' + this.$route.params.id + '/edit').then((response) => {
        if (response.data.code == 200 && response.data.data != null) {
          this.data.permissions = response.data.data.permissions;
          this.data.form        = response.data.data.role;
          this.trans            = response.data.data.trans;
        } else if (response.data.code == 404) {
          router.push('/roles');
        } else {
          alert(response.data.data.error);
          router.push('/roles');
        }
      });
    },
    update() {
      this.data.isRequested = true;
      this.$baseApi.patch('/roles/' + this.data.form.id, this.data.form).then((response) => {
        if (response.data.code === 200) {
          localStorage.setItem('flash_message', 'تمت عملية العديل');
          
          router.push('/roles');
        }
      }).catch((error) => {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },
    selectAll(){
      this.data.form.permissions = []
      setTimeout( () => {
        if (this.data.allSelected) {
          for (let parentPer in this.data.permissions) {
            for (let childPer in this.data.permissions[parentPer]) {
              this.data.form.permissions.push(childPer);
            }
          }
        }
      }, 500)
    },
    select(){
      this.data.allSelected = false;
    },
    selectBox(roles, event) {
      if (event.target.checked) {
        for (let role in roles) {
          if (!this.data.form.permissions.includes(role)) {
            this.data.form.permissions.push(role);
          }
        }
      } else {
        for (let role in roles) {
          const selectedRoleIndex = this.data.form.permissions.findIndex( per => per === role)
          console.log(selectedRoleIndex, role, 'adsd')
          this.data.form.permissions.splice(selectedRoleIndex, 1);
        }
      }
    }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}
.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
